import React from 'react'
import {
  Alert, Container, Row, Col,
  Button, Form, FormGroup, Label, Input, CustomInput
} from 'reactstrap'


export default function contactContainer(props) {

  return (
    <Container>
      <Row>
        <Col>
          <h2 className="h2">Formulario de contacto</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form onSubmit={props.enviarMensaje}>
            {
              props.error &&
              <FormGroup row>
                <Col>
                  <Alert color="danger">
                    {props.error.message}
                  </Alert>
                </Col>
              </FormGroup>
            }
            <FormGroup row>
              <Label for="Nombre" sm={2}>Nombre</Label>
              <Col sm={10}>
                <Input onChange={props.onChange} value={props.Nombre} name="Nombre" id="Nombre" placeholder="Nombre" type="text" required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="Apellido" sm={2}>Apellido</Label>
              <Col sm={10}>
                <Input onChange={props.onChange} value={props.Apellido} name="Apellido" id="Apellido" placeholder="Apellido" type="text" required />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="Correo" sm={2}>Correo electrónico</Label>
              <Col sm={10}>
                <Input onChange={props.onChange} value={props.Correo} type="email" name="Correo" id="Correo" placeholder="nombre@dominio.com" required />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="Telefono" sm={2}>Teléfono</Label>
              <Col sm={10}>
                <Input onChange={props.onChange} value={props.Telefono} type="text" name="Telefono" id="Telefono" placeholder="Teléfono de contacto" />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="Producto" sm={2}>Producto</Label>
              <Col sm={10}>
                {/* <Input onChange={props.onChange} value={props.productId} type="text" name="Producto" id="Producto" placeholder="Producto" /> */}
                <CustomInput type="select" onChange={props.onChangeProduct} value={props.productId ? props.productId : ''} name="Producto" id="Producto" >
                <option value=''>Ninguno</option>
                  {
                    props.products.map(p =>
                      <option
                        key={p.id}
                        value={p.id}
                      >
                        {p.data().Descripcion}
                      </option>
                    )
                  }
                </CustomInput>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="Mensaje" sm={2}>Mensaje</Label>
              <Col sm={10}>
                <Input onChange={props.onChange} value={props.Mensaje} type="textarea" name="Mensaje" id="Mensaje" required />
              </Col>
            </FormGroup>
            {/* <FormGroup row>
              <Label for="Adjunto" sm={2}>Adjunto</Label>
              <Col sm={10}>
                <Input type="file" name="Adjunto" id="Adjunto" />
                <FormText color="muted">
                  El archivo adjunto no puede superar los 5mb.
                  </FormText>
              </Col>
            </FormGroup> */}
            <FormGroup row>
              <Col>
                <Button className="btn-rojo float-right">Enviar</Button>
              </Col>
            </FormGroup>

          </Form>
        </Col>
      </Row>
    </Container>
  )
}